import * as React from 'react';

// TODO Вырезать саджест, полностью его переписать
import { GeoSuggestContainer } from '@/microfrontends/filters/shared/containers/LEGACY/GeoSuggest/container';

import { useFiltersContext } from '../../../utils/context';
import { GeoSwitcherButtonsContainer } from '../GeoSwitcherButtonsContainer';

export const GeoContainer: React.FC = () => {
  const { onChange, onApply } = useFiltersContext();

  return <GeoSuggestContainer rightAddon={<GeoSwitcherButtonsContainer />} onApply={onApply} onChange={onChange} />;
};
